import useGetMyComplaintsAndRelatedData from './useGetMyComplaintsAndRelatedData'

export default useGetMyComplaintsAndRelatedData
